
import React from 'react'
import { Route, Redirect } from 'react-router-dom'

import { getAllCookies, TOKEN, USER_ID, getIsNpiAdmin, getIsAdmin } from 'Lib'
import { setUrlIncoming } from '../../lib'

const Auth = {
	isAuthenticated: () => {
		const cookies = getAllCookies()
		let isAuth = false

		if (cookies && cookies[TOKEN] && cookies[USER_ID]) {
			isAuth = true
		}
		return isAuth
	},
	isNpiAdmin: () => {
		const isAdmin = getIsNpiAdmin()
		return isAdmin.toString() === "true"
	},
	isAdmin: () => {
		const isAdmin = getIsAdmin()
		return isAdmin.toString() === "true"
	}
}

const AdminPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
	<Route {...rest} render={(props) => {
		if (Auth.isAuthenticated() === true && props.match.url !== "/login") {
			let urlIncoming = props.match.url
			setUrlIncome(urlIncoming)
			return <Redirect to='/login' />
		}

		if (Auth.isAdmin() === false) {
			return <Redirect to='/unauthen' />
		}

		if (Layout) {
			return <Layout {...props} Component={Component} />
		} else {
			if (Component !== undefined) {
				return <Component {...props} />
			} else {
				return <Redirect to='/' />
			}
		}
	}} />
)

const NPIPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
	<Route {...rest} render={(props) => {
		if (Auth.isAuthenticated() === true && props.match.url !== "/login") {
			let urlIncoming = props.match.url
			setUrlIncome(urlIncoming)
			return <Redirect to='/login' />
		}

		if (Auth.isNpiAdmin() === false) {
			return <Redirect to='/unauthen' />
		}

		if (Layout) {
			return <Layout {...props} Component={Component} />
		} else {
			if (Component !== undefined) {
				return <Component {...props} />
			} else {
				return <Redirect to='/' />
			}
		}
	}} />
)

const PrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
	<Route {...rest} render={(props) => {
		if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
			let urlIncoming = props.match.url
			setUrlIncoming(urlIncoming)
			return <Redirect to='/login' />
		}

		if (Layout) {
			return <Layout {...props} Component={Component} />
		} else {
			if (Component !== undefined) {
				return <Component {...props} />
			} else {
				return <Redirect to='/' />
			}
		}
	}} />
)

const PublicRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => {
	return <Route {...rest} render={(props) => {

		if (Auth.isAuthenticated() === true && props.match.url === "/login") {
			return <Redirect to='/' />
		}

		if (Layout) {
			return <Layout {...props} Component={Component} />
		} else {
			if (Component !== undefined) {
				return <Component {...props} />
			} else {
				return null
			}
		}
	}} />
}

const setUrlIncome = (url) => {
	setUrlIncoming(url)
}
export {
	PrivateRoute,
	PublicRoute,
	NPIPrivateRoute,
	AdminPrivateRoute,
	Auth,
}


// WEBPACK FOOTER //
// ./src/app/routes/routePermission.js